// Externe Bibliotheken
import { Link } from 'react-router';

// Styles
import './emergencyContactModal.scss';
import { Icon } from '@/comp/icon/icon';

interface EmergencyContactModalProps {
    contactData: {
        name: string;
        phone: string;
        mail: string;
    };
}

const EmergencyContactModal = ({ contactData }: EmergencyContactModalProps) => {
    const { name, phone, mail } = contactData;
    return (
        <>
            <div className="contact-data">
                {name && (
                    <>
                        <div className="contact-data-headline">
                            <Icon name="emergency" className="color-primary" />
                            {`Kontaktdaten für ${name}`}
                        </div>
                        <div className="contact-data-row">
                            <div>Name</div>
                            <div>{name}</div>
                        </div>
                    </>
                )}
                {phone && (
                    <div className="contact-data-row">
                        <div>Handynummer</div>
                        <div>{phone}</div>
                    </div>
                )}
                {mail && (
                    <div className="contact-data-row">
                        <div>Email Adresse</div>
                        <div>{mail}</div>
                    </div>
                )}
            </div>
            <Link to="/notfall-kontakt" className="button-element">
                Kontaktdaten ändern
            </Link>
        </>
    );
};
export default EmergencyContactModal;
